//#region src/tag.ts
/**
* Property key used to brand objects with a tag string.
*
* Defined via `Object.defineProperty` as non-enumerable, non-writable, and
* non-configurable, so it does not appear in `Object.keys`, `JSON.stringify`,
* `for...in`, or spread.
*/
const TAG = "__tag";
/**
* Create a shallow copy of `obj` with a non-enumerable {@link TAG} property.
*
* The original object is not mutated. The tag is defined as non-enumerable,
* non-writable, and non-configurable via `Object.defineProperty`.
*
* @param obj - The source object to copy and tag.
* @param tag - The tag string to brand the copy with.
* @returns A new object with all own enumerable properties of `obj` plus the hidden tag.
*/
function withTag(obj, tag) {
	const copy = { ...obj };
	Object.defineProperty(copy, TAG, {
		configurable: false,
		enumerable: false,
		value: tag,
		writable: false
	});
	return copy;
}
/**
* Type guard that checks whether `value` carries the given tag.
*
* @param value - The value to inspect.
* @param tag - The expected tag string.
* @returns `true` when `value` is a non-null object whose `[TAG]` equals `tag`.
*/
function hasTag(value, tag) {
	if (typeof value !== "object" || value === null) return false;
	return value[TAG] === tag;
}
/**
* Read the tag from a value, if present.
*
* @param value - The value to inspect.
* @returns The tag string, or `undefined` when the value is untagged.
*/
function getTag(value) {
	if (typeof value !== "object" || value === null) return;
	const tag = value[TAG];
	if (typeof tag === "string") return tag;
}
//#endregion
export { TAG, getTag, hasTag, withTag };

//# sourceMappingURL=tag.js.map